import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import Spinner from "../spinner/Spinner";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
import { Link } from "react-router-dom";

const ReturnOrderDetails = () => {
    const [orderDetails, setOrderDetails] = useState({});
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    // Extract returnOrders from location.state
    const returnOrders = location.state.returnOrders;

    useEffect(() => {
        if (returnOrders) {
            //  console.log("This is the order details:", returnOrders);
            setOrderDetails(returnOrders || "");
            setLoading(false);
        } else {
            toast.error("No order details found!");
            setLoading(false);
        }
    }, [returnOrders]);

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Rejected  Items
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">Details</p>
                                </li>
                            </ol>
                        </nav>
                    </section>
                    <div className="flex justify-end">
                        <Link
                            to="/admin/customer/order/return"
                            className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                        >
                            <span className="flex justify-center sm:justify-start mx-2">
                                Go Back
                            </span>
                        </Link>
                    </div>

                    {loading ? (
                        <Spinner loading={loading} />
                    ) : (
                        <div className="p-2 w-full mt-4">
                            <h1 className="text-dash md:text-lg">Return Order Details</h1>
                            <div className="flex items-center border-dash p-1">
                                <div className="relative shadow-md sm:rounded-lg w-full overflow-x-auto">
                                    <table className="min-w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 px-2 py-5">
                                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                            <tr>
                                                <th className="px-6 py-3 border border-darkGreen3 bg-darkGreen3 text-lGrey dark:border-gray-700">
                                                    Details
                                                </th>
                                                <th className="px-6 py-3 border border-gray-300 bg-darkGreen3 text-lGrey dark:border-gray-700">
                                                    Value
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderDetails && (
                                                <>
                                                    <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                        <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                            Customer Name
                                                        </th>
                                                        <td className="px-6 py-4 border border-darkGreen3">
                                                                {orderDetails.user?.firstname || "NOT AVAILABLE"}  {orderDetails.user?.lastname || "NOT AVAILABLE"}
                                                        </td>
                                                    </tr>
                                                        <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                            <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                                Tracking Order Id
                                                            </th>
                                                            <td className="px-6 py-4 border border-darkGreen3">
                                                                {orderDetails.order?.tracking_id || "NOT AVAILABLE"}
                                                            </td>
                                                        </tr>
                                                    <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                        <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                            Total Amount
                                                        </th>
                                                        <td className="px-6 py-4 border border-darkGreen3">
                                                            {CurrencyFormatter(orderDetails.order.total_amount || "NOT AVAILABLE")}
                                                        </td>
                                                    </tr>
                                                    <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                        <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                            Address
                                                        </th>
                                                        <td className="px-6 py-4 border border-darkGreen3">
                                                            {orderDetails.order.address || "NOT AVAILABLE"}
                                                        </td>
                                                    </tr>

                                                    <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                        <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                            Payment Method
                                                        </th>
                                                        <td className="px-6 py-4 border border-darkGreen3">
                                                            {orderDetails.order.payment_method || "NOT AVAILABLE"}
                                                        </td>
                                                    </tr>
                                                    <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                        <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                            Reason
                                                        </th>
                                                        <td className="px-6 py-4 border border-darkGreen3">
                                                            {orderDetails.reason || "NOT AVAILABLE"}
                                                        </td>
                                                    </tr>
                                                    <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                        <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                            Rejected By
                                                        </th>
                                                        <td className="px-6 py-4 border border-darkGreen3">
                                                            {orderDetails.admin?.fullname || "NOT AVAILABLE"}
                                                            <br />
                                                                <span className="px-3 py-0.5 rounded-md text-xs bg-orange1 text-lGrey2">{orderDetails.admin?.email || "NOT AVAILABLE"}</span>
                                                        </td>
                                                    </tr>
                                                </>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Order Items Table */}
                            <h2 className="text-dash md:text-lg mt-6">Order Items</h2>
                            <div className="flex items-center border-dash p-1">
                                <div className="relative shadow-md sm:rounded-lg w-full overflow-x-auto">
                                    <table className="min-w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 px-2 py-5">
                                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                            <tr>
                                                <th className="px-6 py-3 border border-darkGreen3 bg-darkGreen3 text-lGrey dark:border-gray-700">
                                                    Item
                                                </th>
                                                <th className="px-6 py-3 border border-gray-300 bg-darkGreen3 text-lGrey dark:border-gray-700">
                                                    Quantity
                                                </th>
                                                <th className="px-6 py-3 border border-gray-300 bg-darkGreen3 text-lGrey dark:border-gray-700">
                                                    Price
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderDetails.order.order_items && orderDetails.order.order_items.length > 0 ? (
                                                orderDetails.order.order_items.map((item, index) => (
                                                    <tr key={index} className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                        <td className="px-6 py-4 border border-darkGreen3">
                                                            {item.product?.name?.toUpperCase() || "NOT AVAILABLE"}
                                                        </td>
                                                        <td className="px-6 py-4 border border-darkGreen3">
                                                            {item.quantity || 0}
                                                        </td>
                                                        <td className="px-6 py-4 border border-darkGreen3">
                                                            {CurrencyFormatter(item.price || "NOT AVAILABLE")}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="px-6 py-4 text-center">
                                                        No items available.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </MainLayouts>
        </div>
    );
};

export default ReturnOrderDetails;
